import CustomTooltipIcon from "../customTooltipIcon/customTooltipIcon";
import "./tableHeader.scss";

const CustomTableHeader = ({
  title,
  required,
  tooltipText,
  id,
  size,
  style = {},
}) => {
  return (
    <th className="col th-vertical-align-top" key={id} style={style}>
      <div className="th-flex-container">
        <p className="text-align-left">
          {title}
          {required && <span style={{ color: "red" }}>*</span>}
        </p>
        {tooltipText && (
          <CustomTooltipIcon size={size} tooltipText={tooltipText} />
        )}
      </div>
    </th>
  );
};

export default CustomTableHeader;
